import { RouteObject, Navigate } from 'react-router-dom';
import { lazyWithRetry } from '@/utils/lazyWithRetry';

// Lazy-loaded resource pages with retry for network reliability
const FDORACalculator = lazyWithRetry(() => import('@/pages/resources/FDORACalculator'));
const BridgeOnePager = lazyWithRetry(() => import('@/pages/resources/BridgeOnePager'));
const BridgeSovereignty = lazyWithRetry(() => import('@/pages/BridgeSovereignty'));
const UmojaRegOnePager = lazyWithRetry(() => import('@/pages/resources/UmojaRegOnePager'));
const FeasibilityOnePager = lazyWithRetry(() => import('@/pages/resources/FeasibilityOnePager'));
const AfricanAIForHealthOnePager = lazyWithRetry(() => import('@/pages/resources/AfricanAIForHealthOnePager'));
const BridgeCrioOnePager = lazyWithRetry(() => import('@/pages/resources/BridgeCrioOnePager'));
const BridgeFlorenceOnePager = lazyWithRetry(() => import('@/pages/resources/BridgeFlorenceOnePager'));
const AfricaDigitizationOnePager = lazyWithRetry(() => import('@/pages/resources/AfricaDigitizationOnePager'));
const CROOnePager = lazyWithRetry(() => import('@/pages/resources/CROOnePager'));
const FDAInspectionGuide = lazyWithRetry(() => import('@/pages/resources/FDAInspectionGuide'));
const Webinars = lazyWithRetry(() => import('@/pages/resources/Webinars'));
const WebinarDetail = lazyWithRetry(() => import('@/pages/resources/WebinarDetail'));
const QRCodeAssets = lazyWithRetry(() => import('@/pages/resources/QRCodeAssets'));
const CompetitiveAnalysis = lazyWithRetry(() => import('@/pages/resources/CompetitiveAnalysis'));
const UGHEOnePager = lazyWithRetry(() => import('@/pages/resources/UGHEOnePager'));
const EDCTP3TelehealthOnePager = lazyWithRetry(() => import('@/pages/resources/EDCTP3TelehealthOnePager'));
const ValidationDocumentation = lazyWithRetry(() => import('@/pages/ValidationDocumentation'));
const DIEPICValidationProtocol = lazyWithRetry(() => import('@/pages/resources/DIEPICValidationProtocol'));
const HITLSOP = lazyWithRetry(() => import('@/pages/compliance/HITLSOP'));
const PMSPlan = lazyWithRetry(() => import('@/pages/compliance/PMSPlan'));
const GrantsPortfolio = lazyWithRetry(() => import('@/pages/resources/GrantsPortfolio'));
const BridgePortfolioOnePager = lazyWithRetry(() => import('@/pages/resources/BridgePortfolioOnePager'));
const EpmpEastAfricaOnePager = lazyWithRetry(() => import('@/pages/resources/EpmpEastAfricaOnePager'));
const DenguardReadiness = lazyWithRetry(() => import('@/pages/resources/DenguardReadiness'));
const UCTHCaseStudy = lazyWithRetry(() => import('@/pages/resources/UCTHCaseStudy'));
const OptimiseTBCaseStudy = lazyWithRetry(() => import('@/pages/resources/OptimiseTBCaseStudy'));
const SerurubeleRedcapCaseStudy = lazyWithRetry(() => import('@/pages/resources/SerurubeleRedcapCaseStudy'));
const CaseStudyDetail = lazyWithRetry(() => import('@/pages/resources/CaseStudyDetail'));
const BridgeSitelinkOnePager = lazyWithRetry(() => import('@/pages/resources/BridgeSitelinkOnePager'));
const DirectoryForSitesOnePager = lazyWithRetry(() => import('@/pages/resources/DirectoryForSitesOnePager'));
const DirectoryForSponsorsOnePager = lazyWithRetry(() => import('@/pages/resources/DirectoryForSponsorsOnePager'));
const AcademyOnePager = lazyWithRetry(() => import('@/pages/resources/AcademyOnePager'));
const AcademyPublicLanding = lazyWithRetry(() => import('@/pages/AcademyPublicLanding'));
const PHCAcademyPublicLanding = lazyWithRetry(() => import('@/pages/PHCAcademyPublicLanding'));
const TwinNetAcademyPublicLanding = lazyWithRetry(() => import('@/pages/TwinNetAcademyPublicLanding'));

const WhatIsSitelink = lazyWithRetry(() => import('@/pages/resources/WhatIsSitelink'));
const WhatIsSiteCommand = lazyWithRetry(() => import('@/pages/resources/WhatIsSiteCommand'));
const PlatformGuides = lazyWithRetry(() => import('@/pages/resources/PlatformGuides'));
const AeroVascStudy = lazyWithRetry(() => import('@/pages/resources/AeroVascStudy'));
const AeroVascProtocol = lazyWithRetry(() => import('@/pages/resources/AeroVascProtocol'));
const AeroVascCorridorDashboard = lazyWithRetry(() => import('@/pages/resources/AeroVascCorridorDashboard'));
const BridgeSuiteOverview = lazyWithRetry(() => import('@/pages/resources/BridgeSuiteOverview'));
const SecurityArchitectureDocument = lazyWithRetry(() => import('@/pages/resources/SecurityArchitectureDocument'));
const IncidentResponsePlan = lazyWithRetry(() => import('@/pages/resources/IncidentResponsePlan'));
const PDPLComplianceStatement = lazyWithRetry(() => import('@/pages/resources/PDPLComplianceStatement'));
const SecurityComplianceDashboard = lazyWithRetry(() => import('@/pages/resources/SecurityComplianceDashboard'));
const VAPTReadinessChecklist = lazyWithRetry(() => import('@/pages/resources/VAPTReadinessChecklist'));
const SecurityDocumentationHub = lazyWithRetry(() => import('@/pages/resources/SecurityDocumentationHub'));
const BridgeSuiteOnePager = lazyWithRetry(() => import('@/pages/resources/BridgeSuiteOnePager'));
const ChangeManagementLog = lazyWithRetry(() => import('@/pages/resources/ChangeManagementLog'));
const FDORAReadinessToolkit = lazyWithRetry(() => import('@/pages/resources/FDORAReadinessToolkit'));
const AIClinicalDecisionSupport = lazyWithRetry(() => import('@/pages/resources/AIClinicalDecisionSupport'));
const UCTHBlockchainReport = lazyWithRetry(() => import('@/pages/resources/UCTHBlockchainReport'));
const PHCOnePager = lazyWithRetry(() => import('@/pages/resources/PHCOnePager'));
const ETMFOnePager = lazyWithRetry(() => import('@/pages/resources/ETMFOnePager'));
const CDMSOnePager = lazyWithRetry(() => import('@/pages/resources/CDMSOnePager'));
const CTMSOnePager = lazyWithRetry(() => import('@/pages/resources/CTMSOnePager'));
const CRAOnePager = lazyWithRetry(() => import('@/pages/resources/CRAOnePager'));
const BillingOnePager = lazyWithRetry(() => import('@/pages/resources/BillingOnePager'));
const CompetitiveLandscape = lazyWithRetry(() => import('@/pages/resources/CompetitiveLandscape'));
const SponsorPitchDeck = lazyWithRetry(() => import('@/pages/resources/SponsorPitchDeck'));
const EVAHCaseStudy = lazyWithRetry(() => import('@/pages/resources/EVAHCaseStudy'));
const APIDocumentation = lazyWithRetry(() => import('@/pages/resources/APIDocumentation'));
const HealthSystemIntegrations = lazyWithRetry(() => import('@/pages/resources/HealthSystemIntegrations'));
const PipelineOnePager = lazyWithRetry(() => import('@/pages/resources/PipelineOnePager'));
const VillageToVerifiedWhitepaperOnePager = lazyWithRetry(() => import('@/pages/resources/VillageToVerifiedWhitepaperOnePager'));
const MobileMoneyIntegrationOnePager = lazyWithRetry(() => import('@/pages/resources/MobileMoneyIntegrationOnePager'));
const GovSurveillanceOnePager = lazyWithRetry(() => import('@/pages/resources/GovSurveillanceOnePager'));
const TCISConference = lazyWithRetry(() => import('@/pages/resources/TCISConference'));
const ECTDOnePager = lazyWithRetry(() => import('@/pages/resources/ECTDOnePager'));
const EDCTP3IDProtocolsOnePager = lazyWithRetry(() => import('@/pages/resources/EDCTP3IDProtocolsOnePager'));
const PatientOnePager = lazyWithRetry(() => import('@/pages/resources/PatientOnePager'));
const AMRAfricaOnePager = lazyWithRetry(() => import('@/pages/resources/AMRAfricaOnePager'));
const PHCReadinessAssessment = lazyWithRetry(() => import('@/pages/resources/PHCReadinessAssessment'));
// WHOGBTDashboard removed — moved to UmojaReg (/umoja/gbt/dashboard). See umojareg.redirects.ts.
const ECSARegionalDashboard = lazyWithRetry(() => import('@/pages/gov/ECSARegionalDashboard'));
const EDCTP3ConsortiumRollUp = lazyWithRetry(() => import('@/pages/resources/EDCTP3ConsortiumRollUp'));
const EDCTP3RAHub = lazyWithRetry(() => import('@/pages/resources/EDCTP3RAHub'));
const TwinNetSovereign = lazyWithRetry(() => import('@/pages/resources/TwinNetSovereign'));
const EthicsTrackOnePager = lazyWithRetry(() => import('@/pages/resources/EthicsTrackOnePager'));
const SiteReadinessOnePager = lazyWithRetry(() => import('@/pages/resources/SiteReadinessOnePager'));
const OncologySiteReadinessOnePager = lazyWithRetry(() => import('@/pages/resources/OncologySiteReadinessOnePager'));
const ToTLMSOnePager = lazyWithRetry(() => import('@/pages/resources/ToTLMSOnePager'));
const RegulatoryFragmentationOnePager = lazyWithRetry(() => import('@/pages/resources/RegulatoryFragmentationOnePager'));
const CDMSUserGuide = lazyWithRetry(() => import('@/pages/resources/CDMSUserGuide'));
const PatientSelfCheckCDSTOnePager = lazyWithRetry(() => import('@/pages/resources/PatientSelfCheckCDSTOnePager'));
const VHFOutbreakIntelligenceOnePager = lazyWithRetry(() => import('@/pages/resources/VHFOutbreakIntelligenceOnePager'));
const AfricaPHCUplift = lazyWithRetry(() => import('@/pages/resources/AfricaPHCUplift'));
const InstitutionalEndorsements = lazyWithRetry(() => import('@/pages/resources/InstitutionalEndorsements'));
const BridgeValidationStatus = lazyWithRetry(() => import('@/pages/resources/BridgeValidationStatus'));
const GulaProPartner = lazyWithRetry(() => import('@/pages/resources/GulaProPartner'));
const SmallSiteVaccineRubric = lazyWithRetry(() => import('@/pages/resources/SmallSiteVaccineRubric'));
const EFDASaMDCompliance = lazyWithRetry(() => import('@/pages/resources/EFDASaMDCompliance'));
const TMDASaMDCompliance = lazyWithRetry(() => import('@/pages/resources/TMDASaMDCompliance'));
const NDASaMDCompliance = lazyWithRetry(() => import('@/pages/resources/NDASaMDCompliance'));
const PPBSaMDCompliance = lazyWithRetry(() => import('@/pages/resources/PPBSaMDCompliance'));
const NAFDACSaMDCompliance = lazyWithRetry(() => import('@/pages/resources/NAFDACSaMDCompliance'));
const FDAGhanaSaMDCompliance = lazyWithRetry(() => import('@/pages/resources/FDAGhanaSaMDCompliance'));
const ANARMESaMDCompliance = lazyWithRetry(() => import('@/pages/resources/ANARMESaMDCompliance'));
const PMRASaMDCompliance = lazyWithRetry(() => import('@/pages/resources/PMRASaMDCompliance'));
const SAHPRASaMDCompliance = lazyWithRetry(() => import('@/pages/resources/SAHPRASaMDCompliance'));
const RegulatoryPackRequest = lazyWithRetry(() => import('@/pages/resources/RegulatoryPackRequest'));
const RegulatoryPackRequestThankYou = lazyWithRetry(() => import('@/pages/resources/RegulatoryPackRequestThankYou'));
const OnCorePositioning = lazyWithRetry(() => import('@/pages/integrations/OnCorePositioning'));
const Part11Overview = lazyWithRetry(() => import('@/pages/compliance/Part11Overview'));
const TrustHub = lazyWithRetry(() => import('@/pages/TrustHub'));
const ValidationSummary = lazyWithRetry(() => import('@/pages/ValidationSummary'));


export const resourceRoutes: RouteObject[] = [
  {
    path: '/resources/fdora-calculator',
    element: <FDORACalculator />,
  },
  {
    path: '/resources/bridge-one-pager',
    element: <BridgeOnePager />,
  },
  {
    path: '/resources/bridge-six-levels-of-sovereignty',
    element: <BridgeSovereignty />,
  },
  {
    path: '/bridge-sovereignty',
    element: <BridgeSovereignty />,
  },
  {
    path: '/resources/umojareg-one-pager',
    element: <UmojaRegOnePager />,
  },
  {
    path: '/resources/feasibility-one-pager',
    element: <FeasibilityOnePager />,
  },
  {
    path: '/resources/african-ai-for-health',
    element: <AfricanAIForHealthOnePager />,
  },
  {
    path: '/resources/bridge-crio-one-pager',
    element: <BridgeCrioOnePager />,
  },
  {
    path: '/resources/bridge-florence-comparison',
    element: <BridgeFlorenceOnePager />,
  },
  {
    path: '/resources/africa-digitization-one-pager',
    element: <AfricaDigitizationOnePager />,
  },
  {
    path: '/resources/cro-one-pager',
    element: <CROOnePager />,
  },
  {
    path: '/resources/fda-inspection-guide',
    element: <FDAInspectionGuide />,
  },
  {
    path: '/resources/webinars',
    element: <Webinars />,
  },
  {
    path: '/resources/webinars/:id',
    element: <WebinarDetail />,
  },
  {
    path: '/resources/qr-codes',
    element: <QRCodeAssets />,
  },
  {
    path: '/resources/competitive-analysis',
    element: <CompetitiveAnalysis />,
  },
  {
    path: '/resources/ughe-clinical-trials',
    element: <UGHEOnePager />,
  },
  {
    path: '/resources/edctp3-telehealth',
    element: <EDCTP3TelehealthOnePager />,
  },
  {
    path: '/resources/validation-documentation',
    element: <ValidationDocumentation />,
  },
  {
    path: '/validation-documentation',
    element: <ValidationDocumentation />,
  },
  {
    path: '/resources/ucth-case-study',
    element: <UCTHCaseStudy />,
  },
  {
    path: '/resources/optimise-tb-case-study',
    element: <OptimiseTBCaseStudy />,
  },
  {
    path: '/resources/serurubele-redcap-case-study',
    element: <SerurubeleRedcapCaseStudy />,
  },
  {
    path: '/resources/case-studies/:id',
    element: <CaseStudyDetail />,
  },
  {
    path: '/resources/sitelink-one-pager',
    element: <BridgeSitelinkOnePager />,
  },
  {
    path: '/resources/directory-for-sites',
    element: <DirectoryForSitesOnePager />,
  },
  {
    path: '/resources/directory-for-sponsors',
    element: <DirectoryForSponsorsOnePager />,
  },
  {
    path: '/resources/ptc-academy',
    element: <AcademyOnePager />,
  },
  {
    path: '/ptc-academy',
    element: <AcademyPublicLanding />,
  },
  {
    path: '/resources/phc-academy',
    element: <PHCAcademyPublicLanding />,
  },
  {
    path: '/phc-academy',
    element: <PHCAcademyPublicLanding />,
  },
  {
    path: '/resources/twinnet-academy',
    element: <TwinNetAcademyPublicLanding />,
  },
  {
    path: '/twinnet-academy',
    element: <TwinNetAcademyPublicLanding />,
  },
  {
    path: '/resources/what-is-bridge',
    element: <Navigate to="/solutions/bridge-suite" replace />,
  },
  {
    path: '/resources/bridge-suite',
    element: <Navigate to="/solutions/bridge-suite" replace />,
  },
  {
    path: '/resources/what-is-sitelink',
    element: <Navigate to="/solutions/sitelink" replace />,
  },
  {
    path: '/resources/what-is-sitecommand',
    element: <Navigate to="/solutions/sitecommand" replace />,
  },
  {
    path: '/resources/platform-guides',
    element: <PlatformGuides />,
  },
  {
    path: '/resources/aero-vasc-study',
    element: <AeroVascStudy />,
  },
  {
    path: '/resources/aero-vasc-protocol',
    element: <AeroVascProtocol />,
  },
  {
    path: '/resources/aero-vasc-corridor',
    element: <AeroVascCorridorDashboard />,
  },
  {
    path: '/resources/security-architecture',
    element: <SecurityArchitectureDocument />,
  },
  {
    path: '/resources/incident-response-plan',
    element: <IncidentResponsePlan />,
  },
  {
    path: '/resources/pdpl-compliance',
    element: <PDPLComplianceStatement />,
  },
  {
    path: '/resources/security-compliance',
    element: <SecurityComplianceDashboard />,
  },
  {
    path: '/resources/ai-clinical-decision-support',
    element: <Navigate to="/solutions/ai-cdst" replace />,
  },
  {
    path: '/resources/vapt-readiness',
    element: <VAPTReadinessChecklist />,
  },
  {
    path: '/resources/security-hub',
    element: <SecurityDocumentationHub />,
  },
  {
    path: '/resources/endorsements',
    element: <InstitutionalEndorsements />,
  },
  {
    path: '/resources/bridge-validation-status',
    element: <BridgeValidationStatus />,
  },
  {
    path: '/resources/di-epic-validation-protocol',
    element: <DIEPICValidationProtocol />,
  },
  {
    path: '/compliance/hitl-sop',
    element: <HITLSOP />,
  },
  {
    path: '/compliance/pms-plan',
    element: <PMSPlan />,
  },
  {
    path: '/resources/grants',
    element: <GrantsPortfolio />,
  },
  {
    path: '/resources/bridge-portfolio-one-pager',
    element: <BridgePortfolioOnePager />,
  },
  {
    path: '/resources/epmp-east-africa',
    element: <EpmpEastAfricaOnePager />,
  },
  {
    path: '/resources/denguard-readiness',
    element: <DenguardReadiness />,
  },
  {
    path: '/resources/partners/gulapro',
    element: <GulaProPartner />,
  },
  {
    path: '/resources/bridge-suite-one-pager',
    element: <BridgeSuiteOnePager />,
  },
  {
    path: '/resources/change-management-log',
    element: <ChangeManagementLog />,
  },
  {
    path: '/resources/fdora-toolkit',
    element: <FDORAReadinessToolkit />,
  },
  {
    path: '/resources/efda-samd-compliance',
    element: <EFDASaMDCompliance />,
  },
  {
    path: '/resources/tmda-samd-compliance',
    element: <TMDASaMDCompliance />,
  },
  {
    path: '/resources/nda-samd-compliance',
    element: <NDASaMDCompliance />,
  },
  {
    path: '/resources/ppb-samd-compliance',
    element: <PPBSaMDCompliance />,
  },
  {
    path: '/resources/nafdac-samd-compliance',
    element: <NAFDACSaMDCompliance />,
  },
  {
    path: '/resources/fda-ghana-samd-compliance',
    element: <FDAGhanaSaMDCompliance />,
  },
  {
    path: '/resources/anarme-samd-compliance',
    element: <ANARMESaMDCompliance />,
  },
  {
    path: '/resources/pmra-samd-compliance',
    element: <PMRASaMDCompliance />,
  },
  {
    path: '/resources/sahpra-samd-compliance',
    element: <SAHPRASaMDCompliance />,
  },
  {
    path: '/resources/regulatory-pack-request',
    element: <RegulatoryPackRequest />,
  },
  {
    path: '/resources/regulatory-pack-request/thank-you',
    element: <RegulatoryPackRequestThankYou />,
  },
  {
    path: '/resources/ucth-blockchain-report',
    element: <UCTHBlockchainReport />,
  },
  {
    path: '/resources/phc-one-pager',
    element: <PHCOnePager />,
  },
  {
    path: '/resources/etmf-one-pager',
    element: <ETMFOnePager />,
  },
  {
    path: '/resources/cdms-one-pager',
    element: <CDMSOnePager />,
  },
  {
    path: '/resources/ctms-one-pager',
    element: <CTMSOnePager />,
  },
  {
    path: '/resources/cra-one-pager',
    element: <CRAOnePager />,
  },
  {
    path: '/resources/small-site-vaccine-rubric',
    element: <SmallSiteVaccineRubric />,
  },
  {
    path: '/resources/billing-one-pager',
    element: <BillingOnePager />,
  },
  {
    path: '/resources/competitive-landscape',
    element: <CompetitiveLandscape />,
  },
  {
    path: '/resources/sponsor-pitch',
    element: <SponsorPitchDeck />,
  },
  {
    path: '/evah',
    element: <EVAHCaseStudy />,
  },
  {
    path: '/resources/cohort-sponsor-one-pager',
    element: <Navigate to="/for-sponsors" replace />,
  },
  {
    path: '/resources/african-cohort-sponsor-program',
    element: <Navigate to="/for-sponsors" replace />,
  },
  {
    path: '/resources/api-documentation',
    element: <APIDocumentation />,
  },
  {
    path: '/resources/health-system-integrations',
    element: <HealthSystemIntegrations />,
  },
  {
    path: '/resources/pipeline-one-pager',
    element: <PipelineOnePager />,
  },
  {
    path: '/resources/village-to-verified-one-pager',
    element: <VillageToVerifiedWhitepaperOnePager />,
  },
  {
    path: '/resources/mobile-money-integration-one-pager',
    element: <MobileMoneyIntegrationOnePager />,
  },
  {
    path: '/resources/gov-surveillance-one-pager',
    element: <GovSurveillanceOnePager />,
  },
  {
    path: '/resources/tcis-conference',
    element: <TCISConference />,
  },
  {
    path: '/resources/ectd-one-pager',
    element: <ECTDOnePager />,
  },
  {
    path: '/resources/edctp3-id-protocols',
    element: <EDCTP3IDProtocolsOnePager />,
  },
  {
    path: '/resources/patient-one-pager',
    element: <PatientOnePager />,
  },
  {
    path: '/resources/patient-self-check-cdst-one-pager',
    element: <PatientSelfCheckCDSTOnePager />,
  },
  {
    path: '/resources/amr-africa',
    element: <AMRAfricaOnePager />,
  },
  {
    path: '/resources/phc-readiness',
    element: <PHCReadinessAssessment />,
  },
  // /resources/who-gbt-dashboard -> umojareg.org/umoja/gbt/dashboard (renderUmojaregRedirects)
  {
    path: '/resources/ecsa-regional-dashboard',
    element: <ECSARegionalDashboard />,
  },
  {
    path: '/resources/edctp3-consortium-rollup',
    element: <EDCTP3ConsortiumRollUp />,
  },
  {
    path: '/resources/efda-regulator-portal',
    element: <Navigate to="/resources/edctp3-ra-hub" replace />,
  },
  {
    path: '/resources/edctp3-ra-hub',
    element: <EDCTP3RAHub />,
  },
  {
    path: '/resources/twinnet-sovereign',
    element: <TwinNetSovereign />,
  },
  {
    path: '/resources/ethics-track-one-pager',
    element: <EthicsTrackOnePager />,
  },
  {
    path: '/resources/site-readiness-one-pager',
    element: (
      <SiteReadinessOnePager
        crossLink={{
          label: 'Oncology Site Readiness One-Pager',
          href: '/resources/oncology-site-readiness-one-pager',
        }}
      />
    ),
  },
  {
    path: '/resources/oncology-site-readiness-one-pager',
    element: <OncologySiteReadinessOnePager />,
  },
  {
    path: '/resources/tot-lms-one-pager',
    element: <ToTLMSOnePager />,
  },
  {
    path: '/resources/regulatory-fragmentation-one-pager',
    element: <RegulatoryFragmentationOnePager />,
  },
  {
    path: '/resources/cdms-user-guide',
    element: <CDMSUserGuide />,
  },
  {
    path: '/resources/vhf-outbreak-intelligence-one-pager',
    element: <VHFOutbreakIntelligenceOnePager />,
  },
  {
    path: '/resources/africa-phc-uplift',
    element: <AfricaPHCUplift />,
  },
  // Named-URL aliases for procurement / compliance reviewers
  {
    path: '/integrations/oncore',
    element: <OnCorePositioning />,
  },
  {
    path: '/compliance/validation',
    element: <ValidationDocumentation />,
  },
  {
    path: '/compliance/21-cfr-part-11',
    element: <Part11Overview />,
  },
  {
    path: '/trust',
    element: <TrustHub />,
  },
  {
    path: '/trust/validation',
    element: <ValidationSummary />,
  },
];
